import cx from 'classnames';

import { THEME } from '../../../config/commons';

import BarsChart from './BarsChart';
import styles from './Chart.module.scss';
import { Analysis, TypeHorizontalChart } from './interfaces';
import { getHorizontalBarChartData, getHorizontalBarChartOriginalData } from './helper.horizontal-bars-chart';

interface Props {
  analysisData: Analysis;
  typeChart: TypeHorizontalChart;
  textClassName?: string;
  textInsideBarClassName?: string;
  textOutsideBarClassName?: string;
  containerClassName?: string;
  typeStyles?: 'DEFAULT' | 'PDF';
  theme?: 'dark' | 'light';
  width?: number;
  height?: number;
}

function HorizontalBarsChart (props: Props) {
  const {
    textClassName = styles.chartText,
    textInsideBarClassName = styles.textInsideBarClassName,
    textOutsideBarClassName = styles.textOutsideBarClassName,
    containerClassName = styles.container,
    analysisData,
    typeChart,
    typeStyles = 'DEFAULT',
    theme = 'dark',
    width,
    height,
  } = props;


  const { data, weightLabels, measureUnit, percents, averageWeight, isConsolidatedGrowOut } = getHorizontalBarChartData({ typeChart, analysisData });
  const { originalData } = getHorizontalBarChartOriginalData({ typeChart, analysisData, measureUnit });
  const isLightTheme = theme === THEME.LIGHT;

  return (
    <BarsChart
      data={data}
      originalData={originalData}
      weightLabels={weightLabels}
      measureUnit={measureUnit}
      chartType='WEIGHT_GROUPS'
      isConsolidatedGrowOut={isConsolidatedGrowOut}
      percents={percents}
      averageWeight={averageWeight}
      textClassName={textClassName}
      textInsideBarClassName={textInsideBarClassName}
      textOutsideBarClassName={textOutsideBarClassName}
      containerClassName={cx(containerClassName, isLightTheme ? styles.containerLight : styles.containerDark)}
      typeStyles={typeStyles}
      defaultWidth={width}
      defaultHeight={height}
      theme={theme}
    />
  );
}

export default HorizontalBarsChart;
